import React, { useEffect, useState } from 'react'
import './EpisodeCard.scss'
import { CardProps, RailDetailsItem } from '@interfaces/index'
import { ImageSize } from '@enums/images.enum'
import { useImgUrlTransform } from '@hooks/useImgUrlTransform'
import { DocumentData } from 'firebase/firestore'
import Image from '@components/Image/Image'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import classNames from 'classnames'
import { VelvetSDK } from 'sdk'
import { useTypedSelector } from 'store'
import ProgressBar from '@components/ProgressBar/ProgressBar'
import { LocalStorageItem } from '@constants/index'

interface EpisodeCardProps {
  item: CardProps | RailDetailsItem | DocumentData
  isActive?: boolean
  index?: number
  onFocusUpId?: string | null
}

const EpisodeCard = ({ item, isActive, index, onFocusUpId }: EpisodeCardProps) => {
  const {
    id,
    title,
    contextData: { Thumbnail, imageCard },
    description,
  } = item

  const transformedImage = useImgUrlTransform(Thumbnail ?? imageCard, ImageSize.HORIZONTAL_CARD)
  const userObject = JSON.parse(localStorage.getItem(LocalStorageItem.USER_DATA) as string)
  const userIDFromLS = userObject?.userID
  const [episodeDetails, setEpisodeDetails] = useState<DocumentData | null>(null)
  const movie = useTypedSelector((state) => state.movie.movie)
  const activeProfile = JSON.parse(localStorage.getItem(LocalStorageItem.ACTIVE_PROFILE) as string)

  useEffect(() => {
    VelvetSDK.Storage.ResumeWatching.service.getItem(userIDFromLS, item.id, activeProfile.identifier).then((item) => {
      setEpisodeDetails(item)
    })
  }, [activeProfile.identifier, item.id, movie.id, userIDFromLS])

  return (
    <div className={classNames('ec-type', { active: isActive })} id={id} data-sn-up={onFocusUpId}>
      <div className="ec-type-top">
        <Image image={transformedImage} alt={title} fallbackOnLoad />
        <ProgressBar data={episodeDetails} additionalInfoHero={false} isActive={isActive} />
      </div>
      <div className="ec-type-bottom">
        <Text tag={TextTag.P} className="episode-name">
          {index !== undefined ? `${index + 1}. ${title}` : `${title}`}
        </Text>
        <Text tag={TextTag.P} className="episode-description">
          {description}
        </Text>
        {/* Currently we don't receive data from BE for the episodes length, this will remain commented until next changes */}
        {/* <Text tag={TextTag.P} className="episode-length"></Text> */}
      </div>
    </div>
  )
}

export default EpisodeCard
